// extracted by mini-css-extract-plugin
module.exports = {"user-info":"user-info__3Hf_C","user-info-inner":"user-info-inner__A5Zee","active":"active__2r_c1","profile":"profile__2QJAF","name":"name__1xS7Z"};